import axios from 'axios';
import { StorageService } from '../storage';
import { STORAGE_KEYS } from '../../constants';

// Fonction pour gérer les erreurs 401
function handle401Error() {
  console.log('🚨 401 Unauthorized detected via Axios - Clearing auth token and redirecting to login');
  
  // Supprimer le token du localStorage
  StorageService.remove(STORAGE_KEYS.auth_token);
  StorageService.remove(STORAGE_KEYS.user);
  StorageService.remove(STORAGE_KEYS.loggin);
  
  // Supprimer les cookies
  document.cookie = 'jwt_pfid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  if (document.domain !== 'localhost') {
    document.cookie = `jwt_pfid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.${document.domain}; path=/;`;
  }
  
  // Recharger la page pour forcer une nouvelle authentification
  window.location.href = '/';
}

// Intercepteur de réponse pour gérer les erreurs 401
// Désactivé en mode bypass auth (dev) pour éviter une boucle de redirection.
// Garde double : ignoré sur tout build prod (CRA force NODE_ENV=production sur yarn build).
const BYPASS_AUTH =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_BYPASS_AUTH === '1';

axios.interceptors.response.use(
  (response) => {
    // Si la réponse est OK, la retourner
    return response;
  },
  (error) => {
    // Vérifier si c'est une erreur 401
    if (!BYPASS_AUTH && error.response && error.response.status === 401) {
      handle401Error();
    }

    // Rejeter l'erreur pour que les catch locaux puissent la gérer
    return Promise.reject(error);
  }
);

export default axios; 